import { LayoutDashboard, FileText, Users, MapPin, Settings } from 'lucide-react';
import type { NavItem } from '../types';

export const navigation: NavItem[] = [
  { name: 'Dashboard', href: '/admin', icon: LayoutDashboard },
  { name: 'Blog Posts', href: '/admin/blog', icon: FileText },
  { name: 'Service Requests', href: '/admin/requests', icon: Users },
  { name: 'Locations', href: '/admin/locations', icon: MapPin },
  { name: 'Settings', href: '/admin/settings', icon: Settings }
];